export default "__VITE_ASSET__D44YtbAb__"